import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerPaymentMethodTokenDataPropsAndroid from './../../../common/primerPaymentMethodTokenDataProps.mdx';
import ResumeHandlerHeadlessAndroid from './../../_common/resumeHandler.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`This method will be called with the when the payment method has been is tokenized,
returning the payment method's tokenization data. Use the `}<inlineCode parentName="p">{`token`}</inlineCode>{` to create a payment on your backend.
Make sure that you call the `}<inlineCode parentName="p">{`decisionHandler`}</inlineCode>{` once your operation has been completed.`}</p>
    <Callout emoji='⚠️' mdxType="Callout">
      <p>{`This method `}<strong parentName="p">{`will`}</strong>{` be called when you are using `}<inlineCode parentName="p">{`PrimerPaymentHandling.MANUAL`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "./../../../common/settings/primerSettings#properties"
        }}>{`flow`}</a>{`,
or the `}<inlineCode parentName="p">{`PrimerSessionIntent.VAULT`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "./../../../common/primerSessionIntent"
        }}>{`session intent`}</a>{`.`}</p>
    </Callout>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`fun onTokenizeSuccess(
  paymentMethodTokenData: PrimerPaymentMethodTokenData,
  decisionHandler: PrimerHeadlessUniversalCheckoutResumeDecisionHandler
)
`}</code></pre>
    <h3>{`Parameters`}</h3>
    <Group mdxType="Group">
	<Item title='paymentMethodTokenData' subtitle='PrimerPaymentMethodTokenData' label='Required' mdxType="Item">
		<Group summary='Properties' mdxType="Group">
			<PrimerPaymentMethodTokenDataPropsAndroid mdxType="PrimerPaymentMethodTokenDataPropsAndroid" />
		</Group>
	</Item>
	<ResumeHandlerHeadlessAndroid mdxType="ResumeHandlerHeadlessAndroid" />
    </Group>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`class CheckoutActivity : AppCompatActivity() {
  // 👇 Add this
  private val listener = object : PrimerHeadlessUniversalCheckoutListener {
    // 👇 Add this
    override fun onTokenizeSuccess(
      paymentMethodTokenData: PrimerPaymentMethodTokenData,
      decisionHandler: PrimerResumeDecisionHandler
    ) {
        // Create your payment
        val paymentResponse =  //...
        val paymentResponse =  //...
          if (paymentResponse.isSuccessful()) {
            // 👇 Show the success screen, fulfill the order etc..
          } else if (paymentResponse.isPending()) {
            // 👇 Call the decisionHandler with the new client token to continue the flow
            decisionHandler.continueWithNewClientToken(paymentResponse.requiredAction.clientToken)
          } else {
            // 👇 Show the error screen, retry payment...
          }
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      